/**
 * Rentvine API Type Definitions
 * Based on OpenAPI spec and real API responses
 */
/**
 * Contact Type enum (API returns string values)
 * '1' - Owner
 * '2' - Tenant
 * '3' - Vendor
 * '4' - Manager
 * '5' - Association
 * '6' - Applicant
 */
export var RentvineContactType;
(function (RentvineContactType) {
    RentvineContactType["OWNER"] = "1";
    RentvineContactType["TENANT"] = "2";
    RentvineContactType["VENDOR"] = "3";
    RentvineContactType["MANAGER"] = "4";
    RentvineContactType["ASSOCIATION"] = "5";
    RentvineContactType["APPLICANT"] = "6";
})(RentvineContactType || (RentvineContactType = {}));
/**
 * Property Type enum (API returns string values)
 * '1' - Single Family Home
 * '2' - Apartment
 * '3' - Condo
 * '4' - Townhouse
 * '5' - Duplex
 * '6' - Multiplex
 * '7' - Loft
 * '8' - MobileHome
 * '9' - Commercial
 * '10' - Garage
 */
export var RentvinePropertyType;
(function (RentvinePropertyType) {
    RentvinePropertyType["SINGLE_FAMILY_HOME"] = "1";
    RentvinePropertyType["APARTMENT"] = "2";
    RentvinePropertyType["CONDO"] = "3";
    RentvinePropertyType["TOWNHOUSE"] = "4";
    RentvinePropertyType["DUPLEX"] = "5";
    RentvinePropertyType["MULTIPLEX"] = "6";
    RentvinePropertyType["LOFT"] = "7";
    RentvinePropertyType["MOBILE_HOME"] = "8";
    RentvinePropertyType["COMMERCIAL"] = "9";
    RentvinePropertyType["GARAGE"] = "10";
})(RentvinePropertyType || (RentvinePropertyType = {}));
/**
 * Bank Account Type enum (API returns string values)
 * '1' - Savings
 * '2' - Checking
 */
export var RentvineBankAccountType;
(function (RentvineBankAccountType) {
    RentvineBankAccountType["SAVINGS"] = "1";
    RentvineBankAccountType["CHECKING"] = "2";
})(RentvineBankAccountType || (RentvineBankAccountType = {}));
/**
 * Payout Type enum (API returns string values)
 * '1' - Cash
 * '2' - Check
 * '3' - eCheck (ACH)
 * '4' - NACHA (ACH)
 */
export var RentvinePayoutType;
(function (RentvinePayoutType) {
    RentvinePayoutType["CASH"] = "1";
    RentvinePayoutType["CHECK"] = "2";
    RentvinePayoutType["E_CHECK"] = "3";
    RentvinePayoutType["NACHA"] = "4";
})(RentvinePayoutType || (RentvinePayoutType = {}));
// ============================================================================
// WORK ORDER TYPES
// ============================================================================
/**
 * Work Order Priority enum
 * 1 - Low
 * 2 - Medium
 * 3 - High
 */
export var RentvineWorkOrderPriority;
(function (RentvineWorkOrderPriority) {
    RentvineWorkOrderPriority[RentvineWorkOrderPriority["LOW"] = 1] = "LOW";
    RentvineWorkOrderPriority[RentvineWorkOrderPriority["MEDIUM"] = 2] = "MEDIUM";
    RentvineWorkOrderPriority[RentvineWorkOrderPriority["HIGH"] = 3] = "HIGH";
})(RentvineWorkOrderPriority || (RentvineWorkOrderPriority = {}));
/**
 * Work Order Source Type enum (how the work order was created)
 * 1 - Portal
 * 2 - In Person
 * 3 - Email
 * 4 - Text Message
 * 5 - Phone
 * 6 - Recurring
 */
export var RentvineWorkOrderSourceType;
(function (RentvineWorkOrderSourceType) {
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["PORTAL"] = 1] = "PORTAL";
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["IN_PERSON"] = 2] = "IN_PERSON";
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["EMAIL"] = 3] = "EMAIL";
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["TEXT_MESSAGE"] = 4] = "TEXT_MESSAGE";
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["PHONE"] = 5] = "PHONE";
    RentvineWorkOrderSourceType[RentvineWorkOrderSourceType["RECURRING"] = 6] = "RECURRING";
})(RentvineWorkOrderSourceType || (RentvineWorkOrderSourceType = {}));
/**
 * Work Order Primary Status enum
 * 1 - Pending
 * 2 - Open
 * 3 - Closed
 * 4 - On Hold
 */
export var RentvineWorkOrderPrimaryStatus;
(function (RentvineWorkOrderPrimaryStatus) {
    RentvineWorkOrderPrimaryStatus[RentvineWorkOrderPrimaryStatus["PENDING"] = 1] = "PENDING";
    RentvineWorkOrderPrimaryStatus[RentvineWorkOrderPrimaryStatus["OPEN"] = 2] = "OPEN";
    RentvineWorkOrderPrimaryStatus[RentvineWorkOrderPrimaryStatus["CLOSED"] = 3] = "CLOSED";
    RentvineWorkOrderPrimaryStatus[RentvineWorkOrderPrimaryStatus["ON_HOLD"] = 4] = "ON_HOLD";
})(RentvineWorkOrderPrimaryStatus || (RentvineWorkOrderPrimaryStatus = {}));
//# sourceMappingURL=rentvine.js.map